import LogisticsCompany from "@/enum/LogisticsCompany";

/**
 * 索引
 */
type LogisticsCompanyKuaiDi100CodeMapType = {
    [key in LogisticsCompany]?: string;
};

/**
 *  发货易物流公司对应快递100 Code 索引
 */
const LogisticsCompanyKuaiDi100CodeMap: LogisticsCompanyKuaiDi100CodeMapType = {
    [LogisticsCompany.HOAU]: "tdhy",

    [LogisticsCompany.DTW]: "dtwl",

    [LogisticsCompany.ZTO]: "zt",

    [LogisticsCompany.HTKY]: "htky",

    [LogisticsCompany.YUNDA]: "yd",

    [LogisticsCompany.SF]: "sf",

    [LogisticsCompany.EMS]: "ems",

    [LogisticsCompany.STO]: "st",

    [LogisticsCompany.ZJS]: "zjs",

    [LogisticsCompany.YTO]: "yt",

    [LogisticsCompany.POST]: "ems",

    [LogisticsCompany.AIR]: "yfsd",

    [LogisticsCompany.SURE]: "sewl",

    [LogisticsCompany.DBL]: "dbwl",

    [LogisticsCompany.UC]: "yskd",

    [LogisticsCompany.GTO]: "guotongkuaidi",

    [LogisticsCompany.LB]: "lbex",

    [LogisticsCompany.POSTB]: "ems",

    [LogisticsCompany.POSTS]: "yzgn",

    [LogisticsCompany.QRT]: "zengyisudi",

    [LogisticsCompany.FAST]: "kjkd",

    [LogisticsCompany.EYB]: "ems",

    [LogisticsCompany.DBKD]: "dbwl",

    [LogisticsCompany.CNEX]: "jjwl",

    [LogisticsCompany.QFKD]: "quanfengkuaidi",

    [LogisticsCompany.FEDEX]: "fedex",

    [LogisticsCompany.UAPEX]: "qy",

    [LogisticsCompany.BEST]: "htky",

    [LogisticsCompany.JD_EXPRESS]: "jd",

    [LogisticsCompany.BESTQJT]: "htky",

    [LogisticsCompany.RFD]: "rufengda",

    [LogisticsCompany.YCKY]: "ycwl",

    [LogisticsCompany.ANE56]: "annengwuliu",

    [LogisticsCompany.PJBEST]: "pjbest",

    [LogisticsCompany.SNWL]: "suning",

    [LogisticsCompany.SZKKE]: "jgsd",

    [LogisticsCompany.SFKY]: "sf",

    [LogisticsCompany.JT]: "jtexpress",

    [LogisticsCompany.ZTO56]: "zhongtongkuaiyun",

    [LogisticsCompany.YUNDA56]: "yundakuaiyun",

    [LogisticsCompany.ZY]: "zhongyouex",

    [LogisticsCompany.JDKY]: "jd",

    [LogisticsCompany.FENGWANG]: "fengwang",

    [LogisticsCompany.ANE66]: "annengwuliu",

    [LogisticsCompany.JD_HPCP]: "jd",

    [LogisticsCompany.STO56]: "ewl",

    [LogisticsCompany.STOGJ]: "stosolution",

    [LogisticsCompany.ZTOGJ]: "zhongtongguoji",

    [LogisticsCompany.KUAYUE]: "kuayue",

    [LogisticsCompany.EXFRESH]: "exfresh",

    [LogisticsCompany.JIUYESCM]: "jiuyescm",

    [LogisticsCompany.YMDD]: "yimidida",

    [LogisticsCompany.SUT56]: "sut56",

    [LogisticsCompany.JYMWL]: "jymwl",

    [LogisticsCompany.XFWL]: "xfwl",

    [LogisticsCompany.DSWL]: "dskd",

    [LogisticsCompany.CNDTK]: "ytchengnuoda",

    [LogisticsCompany.LWT]: "lhtwl",

    [LogisticsCompany.DFH]: "est365",

    [LogisticsCompany.HMZJB]: "tcat",

    [LogisticsCompany.AXWL]: "anxl",

    [LogisticsCompany.TOPSPEED]: "topspeedex",

    [LogisticsCompany.HUAQIEX]: "huaqikuaiyun",

    [LogisticsCompany.DN]: "danniao",

    [LogisticsCompany.SXJD]: "sxjdfreight",

    [LogisticsCompany.YUNDA_DTD]: "dtd",

    [LogisticsCompany.STE56]: "suteng",

    [LogisticsCompany.ANDE]: "annto",

    [LogisticsCompany.BESTGJ]: "baishiguoji",

    [LogisticsCompany.EWE]: "ewe",

    [LogisticsCompany.GJWL]: "goldjet",

    [LogisticsCompany.RRS]: "rrs",

    [LogisticsCompany.WSPY]: "wtdchina",

    [LogisticsCompany.ZYEHQ]: "cosco",

    [LogisticsCompany.ZYSF]: "zhuanyunsifang",

    [LogisticsCompany.ZZSY]: "chinaicip",

    [LogisticsCompany.PADTF]: "pingandatengfei",

    [LogisticsCompany.KDLL]: "xlair",

    [LogisticsCompany.NZSY]: "nezhasuyun",

    [LogisticsCompany.ZTOCC]: "ztocc",

    [LogisticsCompany.HSYSD]: "huisenky",
};

export default LogisticsCompanyKuaiDi100CodeMap;
